import { useParams } from "react-router-dom";
import { useSimulatorConfiguration } from "./useSimulatorConfiguration";
import { ConfigurationViewGuard } from "./parts/ConfigurationViewGuard";
import { PostAnswerActionsConfiguration } from "./ticket-channel/PostAnswerActionsConfiguration";

export function PostAnswerActionsConfigurationWrapper() {
    const { simulatorId } = useParams();
    const { simulator } = useSimulatorConfiguration(simulatorId);

    const channel = simulator?.channel;

    if (channel !== "autonomous_ticket_event") {
        return null;
    }

    return (
        <ConfigurationViewGuard view={"post_answer_actions"}>
            <PostAnswerActionsConfiguration />
        </ConfigurationViewGuard>
    );
}

